/**
 * The API returns users who are disqualified from ranking (e.g. admins when
 * company.includeAdminInRanking is false) with a position and totalPoints of 0.
 *
 * Only the current user is ever returned excluded — other excluded users are
 * left out of the list entirely — so position 0 appears at most once. The API
 * also deduplicates positions, which makes `position` unique per list and safe
 * to use as a React key. Entries carry no id of their own.
 */
export const isExcludedFromRanking = (entry) => entry?.position === 0;

export const formatLeaderboardPosition = (entry) =>
	isExcludedFromRanking(entry) ? '—' : entry?.position;

export const formatLeaderboardPoints = (entry) =>
	isExcludedFromRanking(entry)
		? 'Excluded'
		: (entry?.totalPoints ?? 0).toLocaleString();

export const isTopThree = (entry) =>
	!isExcludedFromRanking(entry) && entry?.position <= 3;
